import { render, staticRenderFns } from "./empty.pug?vue&type=template&id=a81e78a0&lang=pug&external"
import script from "./empty.js?vue&type=script&lang=js&external"
export * from "./empty.js?vue&type=script&lang=js&external"
import style0 from "./empty.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Multiasistencia\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a81e78a0')) {
      api.createRecord('a81e78a0', component.options)
    } else {
      api.reload('a81e78a0', component.options)
    }
    module.hot.accept("./empty.pug?vue&type=template&id=a81e78a0&lang=pug&external", function () {
      api.rerender('a81e78a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/empty/index.vue"
export default component.exports